var path = 'entity-view/entity-view-card.tpl.html';
var html = " <div flex layout=column style=margin-top:-10px> <div style=text-transform:uppercase;padding-bottom:5px>{{vm.item.type}}</div> <div class=tb-card-description>{{vm.item.additionalInfo.description}}</div> <div style=padding-top:5px class=tb-small ng-show=vm.isAssignedToCustomer()>{{'entity-view.assignedToCustomer' | translate}} '{{vm.item.assignedCustomer.title}}'</div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/entity-view/entity-view-card.tpl.html
// module id = 1454
// module chunks = 1